import React from "react";

import { PeriodicCensusContainer } from "../../../containers";

const PeriodicCensus = (props) => {
  return <PeriodicCensusContainer {...props} />;
};

export default PeriodicCensus;
